import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/SignOut.svg'

export const IconSignOut = IconSVG as IconComponent
